// extracted by mini-css-extract-plugin
export default {"attribution":"Footer_attribution__ddjY9"};